import { useDispatch, useSelector } from 'react-redux'
import { changeCheckedIds, selectCheckedIds } from '../store/slice'
import { Checkbox } from './../../../common/html/checkbox/index'

export const CheckboxCell = ({ rowId }) => {
  const dispatch = useDispatch()

  const checked = useSelector(selectCheckedIds(rowId))

  const onChange = (isCheck) => {
    dispatch(changeCheckedIds({ [rowId]: isCheck }))
  }

  return <Checkbox checked={checked} onChange={onChange} />
}
